var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xl"},[_vm._v("\n sign-up\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }